import React, { useState, useEffect } from "react";
import api from "../../services/api";
import useWrapper from "../../hooks/useWrapper";
import { Content, Main } from "../../components/Layout";
import { Row, Col } from "react-bootstrap";
import Slct from "../../components/Slct";
import Loading from "../../components/Loading";
import Pagenation from "../../components/Pagenation";
import { IntegerNumber, InputText, InputDocument, InputEmail } from "../../components/Input";
import StatusFlag from "../../components/StatusFlag";
import Tooltip2 from "../../components/Tooltip";
import useFormat from "../../hooks/utils/useFormat";
import { toast } from "react-toastify";
import Button from "../../components/Button";
import getCommercial from "../../util/getCommercial";
import TableResponsive from "../../components/TableResponsive";
import Accordion2 from "../../components/Accordion";
import ButtonLink from "../../components/Button/ButtonLink";
import { listTrainees, BOND_FILTER_OPTIONS } from "../../hooks/api/listTrainees";
import MeusDadosIco from "../../components/Svg/new/meus-dados";

export default function Trainees() {
  const { config, setbreadcrumb, permissions } = useWrapper();
  const { formatQuery, formatPhone } = useFormat();

  const [isLoadingEssential, setisLoadingEssential] = useState(false);
  const [isLoadingTrainees, setisLoadingTrainees] = useState();
  const [isWaitingResponse, setisWaitingResponse] = useState();
  useEffect(() => {
    setisWaitingResponse(isLoadingEssential || isLoadingTrainees);
  }, [isLoadingEssential, isLoadingTrainees]);

  const [trainees, settrainees] = useState();
  const filter_init = {};
  const [filter, setfilter] = useState(filter_init);
  const applyFilter = async (__filter, __setPreset) => {
    document.querySelector("#page-filter .accordion-button[aria-expanded='true']")?.click();
    try {
      setisLoadingTrainees(true);
      const _filter = __filter || filter;
      if (!!__filter) setfilter(__filter);

      // `bond_status` vai direto para a query: o scopeFilter genérico do Trainee
      // resolve, e o filtro passa a bater exatamente com o badge. O filtro
      // antigo traduzia rótulo em combinação de flags e divergia do que a tela
      // mostrava (ex.: "Revogado" forçava approve_by_team/aceite_virtual = 1 e
      // não pegava quem tinha access_status = "encerrado").
      const _query = `?joins=null&limite=30&paginate=true&${formatQuery(_filter)}`;

      const _trainees = await listTrainees({
        config,
        query: _query,
      });

      settrainees(_trainees);
    } catch (__error) {
      console.log("__error", __error);
      toast.error("Problemas ao tentar carregar os formandos.");
    } finally {
      setisLoadingTrainees(false);
    }
  };

  const [commercials, setcommercials] = useState([]);
  const [, setinstitutions] = useState([]);
  const [, setcourses] = useState([]);
  useEffect(() => {
    (async () => {
      try {
        setisLoadingEssential(true);
        const _commercials = await getCommercial(null, null, "?is_class=1&joins=institution,course");
        setcommercials(
          [{ value: null, label: "-- Todas --" }].concat(
            _commercials?.map(__commercial => ({
              ...__commercial,
              trainees: [{ value: null, label: "-- Todos --" }].concat(
                __commercial.trainees?.map(__trainee => ({
                  value: __trainee.id,
                  label: __trainee.name,
                })),
              ),
            })),
          ),
        );
        const { data: _institutions } = await api.get("institutions?joins=null&paginate=false", config);
        setinstitutions(
          [{ value: null, label: "-- Todas --" }].concat(
            _institutions?.map(__institution => ({
              value: __institution.id,
              label: __institution.title || "-",
            })),
          ),
        );

        const { data: _courses } = await api.get("courses", config);
        setcourses(
          [{ value: null, label: "-- Todos --" }].concat(
            _courses.map(__course => ({
              value: __course.id,
              label: __course.title,
            })),
          ),
        );
      } catch (__error) {
        console.log("__error", __error);
        toast.error("Erro ao tentar carregar a lista de Turmas e Instituições.");
      } finally {
        setisLoadingEssential(false);
        applyFilter(filter);
      }
    })();
    // applyFilter/config/filter are intentionally excluded: applyFilter is redefined every render
    // and reads `filter` itself, and config is recreated on every WrapperContext render; this effect
    // should only run once on mount to load essential lookup data and apply the initial filter.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setbreadcrumb([{ label: "Formandos" }]);
  }, [setbreadcrumb]);

  return (
    <Main>
      {!isLoadingEssential ? (
        <Content>
          <Row>
            <Col>
              <h2 className="mini-title">Formandos:</h2>
              <p className="small-label mb-3">
                Confira todas os formandos registradas, com informações essenciais e acesso a detalhes completos sobre
                cada um.
              </p>
            </Col>
            {permissions.trainee.create && (
              <Col sm={3} className="d-flex justify-content-end align-items-start">
                <ButtonLink color="primary" to="/trainees/new">
                  Cadastrar Formando
                </ButtonLink>
              </Col>
            )}
          </Row>
          <Accordion2 id="page-filter">
            <Accordion2.Item eventKey={`page-filter`}>
              <Accordion2.Header>
                <span>Filtro</span>
                <Accordion2.Extras>
                  <span>{trainees?.total} resultados</span>
                </Accordion2.Extras>
              </Accordion2.Header>
              <Accordion2.Body>
                <Row>
                  <Col sm={3}>
                    <span>Financeiro</span>
                    <Slct
                      isDisabled={!!isWaitingResponse}
                      options={[
                        { value: null, label: "-- Todos --" },
                        { value: 1, label: "Criado" },
                        { value: 0, label: "Sem Financeiro" },
                      ]}
                      placeholder="..."
                      value={filter?.financial_released}
                      onChange={__ev => {
                        setfilter({
                          ...filter,
                          financial_released: __ev.value,
                        });
                      }}
                    />
                  </Col>
                  <Col sm={6}>
                    <span>Vínculo</span>
                    <Slct
                      isDisabled={!!isWaitingResponse}
                      options={BOND_FILTER_OPTIONS}
                      placeholder="..."
                      value={filter?.bond_status}
                      onChange={__ev => {
                        setfilter({
                          ...filter,
                          bond_status: __ev.value,
                        });
                      }}
                    />
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col sm={6}>
                    <span>Turma</span>
                    <Slct
                      isDisabled={!!isWaitingResponse}
                      options={commercials}
                      placeholder="..."
                      value={filter?.commercial_id}
                      onChange={__ev => {
                        setfilter({
                          ...filter,
                          commercial_id: __ev.value,
                        });
                      }}
                    />
                  </Col>
                  <Col sm={3}>
                    <span>Ano/Período</span>
                    <div className="ano-periodo">
                      <IntegerNumber
                        disabled={!!isWaitingResponse}
                        value={filter?.year}
                        valueChange={__ev => {
                          setfilter({
                            ...filter,
                            year: __ev,
                          });
                        }}
                        maxlength="4"
                      />
                      <Slct
                        isDisabled={!!isWaitingResponse}
                        options={[
                          { value: null, label: "1 e 2" },
                          { value: 1, label: "1" },
                          { value: 2, label: "2" },
                        ]}
                        placeholder="..."
                        value={filter?.["commercials.period"]}
                        onChange={e => {
                          setfilter({
                            ...filter,
                            "commercials.period": e.value,
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col sm={6}>
                    <span>Nome</span>
                    <InputText
                      disabled={!!isWaitingResponse}
                      placeholder="..."
                      value={filter?.name}
                      onChange={__ev => {
                        setfilter({
                          ...filter,
                          name: __ev.target.value,
                        });
                      }}
                    />
                  </Col>
                  <Col sm={3}>
                    <span>CPF</span>
                    <InputDocument
                      disabled={!!isWaitingResponse}
                      type="cpf"
                      value={filter?.cpf || ""}
                      valueChange={__ev => {
                        setfilter({
                          ...filter,
                          cpf: __ev,
                        });
                      }}
                    />
                  </Col>
                  <Col sm={3}>
                    <span>E-Mail</span>
                    <InputEmail
                      disabled={!!isWaitingResponse}
                      value={filter?.email}
                      onChange={__ev => {
                        setfilter({
                          ...filter,
                          email: __ev.target.value,
                        });
                      }}
                      placeholder="usuario@email.com"
                    />
                  </Col>
                </Row>
                {!isWaitingResponse && (
                  <Row className="mt-3">
                    <Col>
                      <Button
                        color="primary"
                        size="sm"
                        onClick={() => {
                          applyFilter();
                        }}
                      >
                        Aplicar Filtro
                      </Button>
                      <Button
                        color="grey"
                        size="sm"
                        onClick={() => {
                          applyFilter(filter_init);
                        }}
                      >
                        Limpar Filtro
                      </Button>
                    </Col>
                  </Row>
                )}
              </Accordion2.Body>
            </Accordion2.Item>
          </Accordion2>
          <Row className="mt-4">
            <Col>
              {!isLoadingTrainees ? (
                <>
                  <TableResponsive
                    emptyMsg="Nenhuma formando encontrado."
                    table={{
                      head: [
                        { data: "ID" },
                        { data: "Formando" },
                        { data: "Turma" },
                        { data: "Contato" },
                        { data: <div className="text-end">Financeiro</div> },
                        { data: <div className="text-end">Vínculo</div> },
                        { data: <div className="text-end">Aceite</div> },
                      ],
                      body:
                        trainees?.data?.map(__trainee => {
                          return {
                            link: `/trainees/edit/${__trainee.id}`,
                            disabled: !!__trainee?.cancel,
                            data: [
                              { element: __trainee.id },
                              {
                                element: (
                                  <>
                                    {__trainee.is_member ? (
                                      <span className="smaller-ico">
                                        <MeusDadosIco />
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                    {__trainee.name}
                                  </>
                                ),
                              },
                              {
                                element:
                                  commercials?.find(__commercial => __commercial.value === __trainee.commercial_id)
                                    ?.label || "-",
                              },
                              {
                                element: (
                                  <>
                                    <p className="m-0">{formatPhone(__trainee?.cell)}</p>
                                    <p className="m-0">{__trainee?.email}</p>
                                  </>
                                ),
                              },
                              {
                                element: (
                                  <div className="text-end">
                                    <StatusFlag status={!__trainee?.financial_released ? "Sem Financeiro" : "Criado"} />
                                  </div>
                                ),
                              },
                              {
                                element: (
                                  <div className="text-end">
                                    <StatusFlag status={__trainee?.bond || "?"} tone={__trainee?.bond_tone}>
                                      {__trainee?.bond_short || __trainee?.bond || "?"}
                                    </StatusFlag>
                                  </div>
                                ),
                              },
                              {
                                element: (
                                  <div className="text-end">
                                    {/* o link da linha (TableResponsive) cobre a célula inteira e
                                        engoliria o hover; o badge sobe acima dele para o tooltip
                                        funcionar, levando o mesmo link para o clique não mudar */}
                                    <Tooltip2 tip={__trainee?.aceite_tip}>
                                      <a
                                        href={`/trainees/edit/${__trainee.id}`}
                                        className="position-relative z-1 text-decoration-none"
                                      >
                                        <StatusFlag status={__trainee?.aceite} tone={__trainee?.aceite_tone} />
                                      </a>
                                    </Tooltip2>
                                  </div>
                                ),
                              },
                            ],
                          };
                        }) || [],
                    }}
                  />
                  <Pagenation
                    current={trainees?.page}
                    total={trainees?.lastPage}
                    pageChange={__page => {
                      applyFilter({
                        ...filter,
                        page: __page,
                      });
                    }}
                    className="mt-4"
                  />
                </>
              ) : (
                <Loading />
              )}
            </Col>
          </Row>
        </Content>
      ) : (
        <Content>
          <Loading />
        </Content>
      )}
    </Main>
  );
}
